import { useLocation, useNavigate } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

export default function Confirmation() {
    const navigate = useNavigate();
    const loc = useLocation();
    const submissionId = loc.state?.submissionId || "—";

    return (
        <div className="intake-shell flex items-center justify-center px-6 py-12" data-testid="confirmation-page">
            <div className="intake-card w-full max-w-xl p-10 text-center animate-fade-up">
                <div className="mx-auto w-16 h-16 rounded-full bg-[#D4AF37]/15 border border-[#D4AF37]/40 flex items-center justify-center mb-6 shadow-[0_0_30px_rgba(212,175,55,0.25)]">
                    <CheckCircle2 className="text-[#D4AF37]" size={28} />
                </div>
                <h1 className="font-display text-4xl sm:text-5xl text-white">Submission received</h1>
                <p className="mt-4 text-white/60">
                    Thank you. Your application has been securely received. A specialist will reach out shortly to walk you through next steps.
                </p>
                <div className="mt-8 px-4 py-4 rounded-xl border border-white/10 bg-white/[0.03] text-left">
                    <div className="field-label">Reference number</div>
                    <div className="mt-1 font-mono text-sm text-white/90 break-all" data-testid="confirmation-submission-id">
                        {submissionId}
                    </div>
                </div>
                <button
                    onClick={() => navigate("/")}
                    className="btn-ghost-light mt-8 px-6 py-3"
                    data-testid="confirmation-home-btn"
                >
                    Back to home
                </button>
            </div>
        </div>
    );
}
